import React from 'react';
import {
  HtmlEditor,
  Image,
  Inject,
  Link,
  QuickToolbar,
  RichTextEditorComponent,
  Toolbar,
} from '@syncfusion/ej2-react-richtexteditor';

function RichTextEditorInput({
  activeSwitch,
  asteriskOn,
  disabled,
  errorMessage,
  height,
  label,
  name,
  onChange,
  onSwitch,
  showIncludeSwitch,
  style,
  value,
}) {

  // Default RTE toolbar settings
  let toolbarSettings = {
    items: [
      'Bold',
      'Italic',
      'Underline',
      'StrikeThrough',
      'FontName',
      'FontSize',
      'FontColor',
      'BackgroundColor',
      'LowerCase',
      'UpperCase',
      '|',
      'Formats',
      'Alignments',
      'OrderedList',
      'UnorderedList',
      'Outdent',
      'Indent',
      '|',
      'CreateLink',
      'Image',
      '|',
      'ClearFormat',
      'Print',
      'SourceCode',
      'FullScreen',
      '|',
      'Undo',
      'Redo',
    ],
    type: 'Scrollable',
  };
  
  return (
    <div>
      <div className={'d-flex position-relative'}>
        {label && (
          <div className={'text-area-label'}>
            {label}
            {asteriskOn && <span style={{ color: '#FF0000' }}>*</span>}
          </div>
        )}

        {showIncludeSwitch && (
          <div style={{ marginTop: '-3px', position: 'absolute', right: '0' }}>
            <Switch
              active={activeSwitch}
              label={'Include'}
              onSwitch={onSwitch}
            />
          </div>
        )}
      </div>

      <div className="rte-wrapper">
        <RichTextEditorComponent
          change={(args) => {
            onChange({
              name,
              value: args.value,
            });
          }}
          disabled={disabled}
          name={name}
          toolbarSettings={toolbarSettings}
          value={value}
          style={style}
        >
          <Inject services={[HtmlEditor, Image, Link, Toolbar, QuickToolbar]} />
        </RichTextEditorComponent>
      </div>

      {errorMessage && (
        <small className={'compose-email-form-error-message'}>
          {errorMessage}
        </small>
      )}
    </div>
  );
}

export default RichTextEditorInput;
